<template>
  <div class="ChartsBorderConfiger">
    <span>选择边框</span>
    <el-select
      @change="handleChange"
      v-model="curreentBorderName"
      placeholder="请选择边框"
      popper-class="ChartsBorderConfiger"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: 'ChartsBorderConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      options: [
        {
          value: 'Charts0Border',
          label: '无边框',
        },
        {
          value: 'Charts1Border',
          label: '边框一',
        },
        {
          value: 'Charts2Border',
          label: '边框二',
        },
      ],
      curreentBorderName: '',
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    initData() {
      this.curreentBorderName = this.CurrentConfigration.propertyData.borderConfig.value.borderComponentName;
    },
    handleChange(val) {
      let sendVal = {
        borderComponentName: val,
      };
      this.commitCurrentPropertyData(sendVal);
    },
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ChartsBorderConfiger {
  width: 100%;
  margin: 10px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-select {
    width: 150px;
  }
  span {
    box-sizing: border-box;
    color: $property-title-color;
    font-size: $property-title-size;
  }
  padding: 0 15px;
  :deep().el-input input {
    height: 35px;
    color: #b6b8cc;
    background: #191b23;
    text-align: center;
    border: 1px solid rgba(139, 139, 139, 0.733);
    &:hover {
      border: 1px solid #3179ff;
    }
    &:focus {
      border: 1px solid #3179ff;
    }
  }
}
</style>
